// extracted by mini-css-extract-plugin
export default {"button":"hXdMd","text":"R1jb2"};